import React, { useState } from "react";
import "./Portfolio.css";
import Menu from "./Menu";
import { motion } from "framer-motion";
import ProjectDrawer from "../projects/project.jsx";

const Portfolio = () => {
  const [items, setItems] = useState(Menu);
  const [activeFilter, setActiveFilter] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);

  const filterItems = (categoryItem) => {
    const updatedItems = Menu.filter((curElem) =>
      curElem.category.includes(categoryItem)
    );
    setItems(updatedItems);
  };

  return (
    <section className="portfolio container section" id="portfolio">
      <h2 className="section__title">Recent Projects</h2>

      <div className="portfolio__filters">
        {["All", "Frontend", "Backend", "Figma", "React"].map((cat, i) => (
          <span
            key={cat}
            className={
              activeFilter === i
                ? "portfolio__item portfolio__item-active"
                : "portfolio__item"
            }
            onClick={() => {
              cat === "All" ? setItems(Menu) : filterItems(cat);
              setActiveFilter(i);
            }}
          >
            {cat}
          </span>
        ))}
      </div>

      <div className="portfolio__container grid">
        {items.map((elem) => {
          const { id, image, title, category } = elem;

          return (
            <motion.div
              layout
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="portfolio__card"
              key={id}
              onClick={() => setSelectedProject(elem)}
            >
              <div className="portfolio__thumbnail">
                <img src={image} alt={title} className="portfolio__img" />
              </div>

              <div className="portfolio__hover-info">
                <h3 className="portfolio__title">{title}</h3>
                <span className="portfolio__category">{category.join(", ")}</span>
              </div>
            </motion.div>
          );
        })}
      </div>

      <ProjectDrawer
        project={selectedProject}
        onClose={() => setSelectedProject(null)}
      />
    </section>
  );
};

export default Portfolio;
